type HeaderBarItem = {
  type: string,
  data: any,
}

type HeaderMenuItem = {
  id: string,
  title: string,
  route: string,
  total?: number,
  onlyPathname?: boolean,
}

export const enum WebmasterVerificationStatusId {
  NotVerified = 0,
  InProgress = 1,
  Verified = 2,
}

export type WebmasterVerificationStatus = {
  id: WebmasterVerificationStatusId,
  name: string,
}

export interface HeaderReducer {
  header: {
    showHeader: boolean,
    showFooter: boolean,
    needDocumentForPayment: boolean

    slogan: string | null,

    backlink: string | Location | null,
    backlinkText: string | null,

    bar: HeaderBarItem[],

    title: string | null,

    menu: HeaderMenuItem[],
    menuShow: boolean,
    menuValue: string | false,

    events: {
      eventById: unknown,
    },

    manager: {
      name: string,
      avatar: string,
      email: string,
    }

    user: {
      email: string,
      id: number,
      isBanned: boolean,
      isBlogger: boolean,
      name: string,
      phoneVerified: boolean,
      xkey: string,
      verificationStatus: WebmasterVerificationStatusId,
    }
  }
}
